import moment from "moment-timezone";

import * as date from "@/utils/date";

const getWorkDayTimeValue = ({ oldTime, newTime }) => {
  if (oldTime && newTime) {
    // Check if value is not equal
    if (oldTime !== newTime) {
      // use newTime
      return newTime;
    }
    return oldTime;
  }
  if (!oldTime && newTime) {
    return newTime;
  }
  if (oldTime && !newTime) {
    return oldTime;
  }
  return null;

  // else if (oldTime && !newTime) {
  //   return null;
  // } else if (!oldTime && !newTime) {
  //   return null;
  // } else {
  //   return null;
  // }
};

// The old work days live in Redux as viewer-local "HH:mm" and on the server as UTC. Shared with
// the Time Tracking page's own-value save so its flag-off work-day edits convert as this save does.
export const toLocalWorkDay = (w) => {
  const dateToday = moment().format("YYYY-MM-DD");
  return {
    ...w,
    start: w.start
      ? date.toLocalDateTime({
          date: moment.utc(`${dateToday} ${w.start}`, "YYYY-MM-DD HH:mm"),
          timezone: date.getCurrentUserTimezone(),
          format: "HH:mm",
        })
      : null,
    end: w.end
      ? date.toLocalDateTime({
          date: moment.utc(`${dateToday} ${w.end}`, "YYYY-MM-DD HH:mm"),
          timezone: date.getCurrentUserTimezone(),
          format: "HH:mm",
        })
      : null,
  };
};

export const toServerWorkDay = (workDay, w) => {
  const start = getWorkDayTimeValue({ oldTime: workDay.start, newTime: w.start });
  const end = getWorkDayTimeValue({ oldTime: workDay.end, newTime: w.end });

  return {
    ...w,
    start: start
      ? date.toUtcDateTime({
          date: `${moment().format("YYYY-MM-DD")}T${start}:00`,
          timezone: date.getCurrentUserTimezone(),
          format: "HH:mm",
        })
      : null,
    end: end
      ? date.toUtcDateTime({
          date: `${moment().format("YYYY-MM-DD")}T${end}:00`,
          timezone: date.getCurrentUserTimezone(),
          format: "HH:mm",
        })
      : null,
  };
};
